/**
 * One idea: a summary strip (verdict and total, recommendation, rationale, summary, profile radar, dimensions table) over one content
 * card holding the research report with a sticky section index. What was
 * submitted and every research run open in dialogs from the facts card.
 * While research is queued or running the page refreshes on its own. Past
 * runs open in place. The parts live in ./detail.
 */

import { PageHead } from '@/ui/PageHead';
import { LoadFailure, LoadingCard } from '@/ui/StateCard';

import { IdeaDetailBody } from './detail/IdeaDetailBody';
import { useIdeaDetail } from './detail/useIdeaDetail';

function backOf(from: string | undefined) {
  return { to: from ?? '/business-opportunities', name: from?.startsWith('/dashboard') ? 'Dashboard' : 'Business Opportunities' };
}

export function BusinessOpportunityDetailPage() {
  const { idea, catalogue, from, ui } = useIdeaDetail();
  const back = backOf(from);
  const head = <PageHead title="Business opportunity" back={back} />;

  if (idea.isPending || catalogue.isPending) return <>{head}<LoadingCard label="Loading the idea" /></>;
  if (idea.error) return <>{head}<LoadFailure error={idea.error} onRetry={() => void idea.refetch()} /></>;
  if (catalogue.error) return <>{head}<LoadFailure error={catalogue.error} onRetry={() => void catalogue.refetch()} /></>;

  return (
    <IdeaDetailBody idea={idea.data} dimensions={catalogue.data.dimensions} ui={ui} back={back} />
  );
}
